// OTP authentication helpers for the share-web SPA.
// Both functions use `credentials: 'include'` so the Set-Cookie from verify
// sticks as a session cookie for subsequent gated manifest fetches.

export async function requestOtp(email: string, apiBase = ''): Promise<{ ok: boolean; error?: string }> {
  try {
    const res = await fetch(`${apiBase}/api/auth/request`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (!res.ok) {
      const b = await res.json().catch(() => ({}));
      return { ok: false, error: (b as any).error || `request_${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String((e as Error)?.message || e) };
  }
}

export async function verifyOtp(email: string, code: string, apiBase = ''): Promise<{ ok: boolean; error?: string }> {
  try {
    const res = await fetch(`${apiBase}/api/auth/verify`, {
      method: 'POST',
      credentials: 'include', // include so Set-Cookie sticks
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ email, code, platform: 'web' }),
    });
    if (!res.ok) {
      const b = await res.json().catch(() => ({}));
      return { ok: false, error: (b as any).error || `verify_${res.status}` };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String((e as Error)?.message || e) };
  }
}
